<template>
    <div class="card-group" v-if="dados">
        <div class="card" v-for="(agendas, dia, idx) in dados.agendas" :key="idx"
          :class="dia == referencia ? 'border-primary' : ''">
          <div class="card-body small p-2">
            <div class="d-flex justify-content-between">
              <div>
                <span class="badge badge-dark mr-2">
                  {{ $util.getFormatDate(dia, 'ddd') }}
                </span>
                <a href="#" @click.prevent="trocar_data(dia)" class="card-link">
                  {{ $util.getFormatDate(dia, 'DD/MM') }}
                </a>
              </div>
              <div>
                <span class="badge" :class="'badge-' + dados.marcacoes[dia].cor">
                  {{ dados.marcacoes[dia].marcados }}/{{ dados.marcacoes[dia].disponibilidade }}
                </span>
              </div>
            </div>
            <div v-for="(agenda, iax) in agendas" :key="iax">
              <span class="mr-2" v-if="agenda.search">{{ agenda.search }}</span>
              <span class="text-muted" v-if="agenda.st_titulo">{{ agenda.st_titulo }}</span>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['dados', 'referencia'],

    methods: { 
        trocar_data (dia) { 
            this.$emit('trocar', dia);
        }
    },
}
</script>